<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    fill="none"
    viewBox="0 0 500 500"
    data-app="Xyris"
  >
    <defs></defs>
    <g transform-origin="center" style="transform-box: fill-box" transform="">
      <path
        d="M 388 351.939 C 388 361.328 380.389 368.939 371 368.939 C 361.611 368.939 354 361.328 354 351.939 C 354 342.549 361.611 334.939 371 334.939 C 380.389 334.939 388 342.549 388 351.939 Z"
        fill="#F08B30"
        transform-origin="center"
        transform="matrix(1,0,0,1,-374,-354.9389953613281)"
        style="transform-box: fill-box"
      >
        <animateMotion
          begin="-0.00001"
          dur="1.728503606557377"
          keyTimes="0; 1"
          keyPoints="0; 1.0"
          fill="freeze"
          keySplines="0 0 1 1"
          repeatCount="indefinite"
          calcMode="spline"
        >
          <mpath href="#motion-path-rsZedAHwK61uBtgb7EB6v8"></mpath>
        </animateMotion>
        <animateTransform
          attributeName="transform"
          type="scale"
          begin="-0.00001"
          dur="1.728503606557377"
          keyTimes="0; 0.5264730290456432; 1"
          values="1, 1;1.2;1, 1"
          fill="freeze"
          additive="sum"
          calcMode="spline"
          keySplines="0 0 1 1; 0 0 1 1"
          repeatCount="indefinite"
        ></animateTransform>
      </path>
      <path
        d="M 172.321 260.109 C 172.321 328.989 225.576 384.83 291.27 384.83 C 356.964 384.83 410.219 328.989 410.219 260.109 C 410.219 191.227 356.964 135.387 291.27 135.387 C 225.576 135.387 172.321 191.227 172.321 260.109 Z"
        fill="none"
        stroke="#000000"
        stroke-width="0"
        transform=""
        id="motion-path-rsZedAHwK61uBtgb7EB6v8"
      ></path>
    </g>
    <g transform-origin="center" style="transform-box: fill-box" transform="">
      <path
        d="M 289.827 59.689 C 374.021 59.689 442.273 121.823 442.273 198.469 C 442.273 275.116 374.021 337.25 289.827 337.25 C 205.634 337.25 137.382 275.116 137.382 198.469 C 137.382 121.823 205.634 59.689 289.827 59.689 Z"
        fill="none"
        stroke="#000000"
        stroke-width="0"
        id="motion-path-71rLT3fNMLZvhuJQKGGoes"
        transform=""
      ></path>
      <path
        d="M 397.5 142.939 C 416.554 142.939 432 127.493 432 108.439 C 432 89.3851 416.554 73.9388 397.5 73.9388 C 378.446 73.9388 363 89.3851 363 108.439 C 363 127.493 378.446 142.939 397.5 142.939 Z"
        fill="#F08B30"
        transform-origin="center"
        transform="matrix(1,0,0,1,-400.5,-111.43889617919922)"
        style="transform-box: fill-box"
        stroke-width="1"
      >
        <animateMotion
          begin="-0.00001"
          dur="2.036521024590164"
          keyTimes="0; 1"
          keyPoints="0; 1.0"
          fill="freeze"
          keySplines="0 0 1 1"
          repeatCount="indefinite"
          calcMode="spline"
        >
          <mpath href="#motion-path-71rLT3fNMLZvhuJQKGGoes"></mpath>
        </animateMotion>
        <animateTransform
          attributeName="transform"
          type="scale"
          begin="-0.00001"
          dur="2.036521024590164"
          keyTimes="0; 0.5479125744389564; 1"
          values="1, 1; 0.8; 1, 1"
          fill="freeze"
          additive="sum"
          calcMode="spline"
          keySplines="0 0 1 1; 0 0 1 1"
          repeatCount="indefinite"
        ></animateTransform>
      </path>
    </g>
    <g
      transform-origin="center"
      transform="matrix(1,0,0,1,-52,-52)"
      style="transform-box: fill-box"
    >
      <path
        d="M 49 101 C 77.719 101 101 77.72 101 49 C 101 20.28 77.719 -3 49 -3 C 20.2812 -3 -3 20.28 -3 49 C -3 77.72 20.2812 101 49 101 Z"
        fill="#F08B30"
        transform-origin="center"
        style="transform-box: fill-box"
        stroke-width="0"
        transform="matrix(1,0,0,1,-52,-52)"
      >
        <animateMotion
          begin="-0.8516476201923077"
          dur="2.5478715624999992"
          fill="freeze"
          repeatCount="indefinite"
        >
          <mpath href="#motion-path-7rCxN9GLMjqZQHyui22RLS"></mpath>
        </animateMotion>
        <animateTransform
          attributeName="transform"
          type="scale"
          begin="-0.8490184134615384"
          dur="2.5478715624999997"
          keyTimes="0; 0.5055239555385206; 1"
          values="1, 1; 1.1; 1, 1"
          fill="freeze"
          additive="sum"
          calcMode="spline"
          keySplines="0 0 1 1;0 0 1 1"
          repeatCount="indefinite"
        ></animateTransform>
      </path>
      <path
        d="M 308.424 140.133 C 406.762 140.133 486.48 218.454 486.48 315.07 C 486.48 411.683 406.762 490.006 308.424 490.006 C 210.087 490.006 130.37 411.683 130.37 315.07 C 130.37 218.454 210.087 140.133 308.424 140.133 Z"
        fill="none"
        stroke="#000000"
        stroke-width="0"
        id="motion-path-7rCxN9GLMjqZQHyui22RLS"
      ></path>
    </g>
    <g transform="">
      <path
        d="M 72 147 C 113.421 147 147 113.421 147 72 C 147 30.579 113.421 -2.99999 72 -2.99999 C 30.579 -2.99999 -3 30.579 -3 72 C -3 113.421 30.579 147 72 147 Z"
        fill="#3043F0"
        transform-origin="center"
        style="transform-box: fill-box"
        transform="matrix(1,0,0,1,-75,-75.00001525878906)"
      >
        <animateMotion
          begin="-0.00001"
          dur="3.00002"
          keyTimes="0; 1.0"
          keyPoints="0; 1.0"
          fill="freeze"
          keySplines="0 0 1 1"
          repeatCount="indefinite"
          calcMode="spline"
        >
          <mpath href="#motion-path-x2zrZTR3aAELdofXtRbaEZ"></mpath>
        </animateMotion>
      </path>
      <path
        d="M 261.202 242.277 L 261.202 239.781 L 266.164 242.277 L 266.164 239.59 L 261.202 242.277"
        stroke-width="0"
        stroke="#6B67FD"
        fill="none"
        transform=""
        id="motion-path-x2zrZTR3aAELdofXtRbaEZ"
      ></path>
    </g>
  </svg>
</template>
